import { render, staticRenderFns } from "./ed-chip.vue?vue&type=template&id=5b7171c5&scoped=true&"
import script from "./ed-chip.ts?vue&type=script&lang=js&"
export * from "./ed-chip.ts?vue&type=script&lang=js&"
import style0 from "./ed-chip.scss?vue&type=style&index=0&id=5b7171c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7171c5",
  null
  
)

export default component.exports